import { useNavigate } from "react-router-dom";
import { EvtHeader } from "components/header";
import { DISCORD, DRIVE, GITHUB } from "icons";
import IntegrationCard from "./components/card";

const CARDS = [
  { title: "Github", icon: GITHUB, label: "Repositories", path: "/integrations/github" },
  { title: "Discord", icon: DISCORD, label: "Channels", path: "/integrations/discord" },
  { title: "Drive", icon: DRIVE, label: "Folders", path: "/integrations/drive" },
];

export default function IntegrationsHub() {
  const navigate = useNavigate();
  return (
    <div className="flex-1">
      <div className="py-2">
        <EvtHeader title="Integrations" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 px-4 gap-4 md:px-6 py-6">
        {CARDS.map((card) => (
          <IntegrationCard
            key={card.title}
            title={card.title}
            icon={card.icon}
            label={card.label}
            onClick={() => navigate(card.path)}
          />
        ))}
      </div>
    </div>
  );
}
